export function extendJQuery() {
  
  /**
   * Works the same way as vanilla JS forEach method
   * Unlike jQuery each method, this one iterates over set of elements as jQuery objects
   * @param {callable} callback Arguments provided: element wrapped in jQuery, iteration index, 'this' from context of jQuery.each
   */
  jQuery.fn.forEach = function(callback = jQuery.noop) {
    this.each((i, element) => {
      callback(jQuery(element), i, this);
    });
  };
  
  /**
   *
   * @param {function(jQuery, number, jQuery)} callback
   * @returns {jQuery|HTMLElement}
   */
  jQuery.fn.filterEach = function(callback = jQuery.noop) {
    let accum = this.toArray().filter((element, i) => {
      return !!callback(jQuery(element), i, this);
    });
    return $(accum);
  };
  /**
   * Map set of jQuery elements using vanilla JS map function
   * @param callback Same callback as in Array.prototype.map method
   * @returns {Array}
   */
  jQuery.fn.mapEach = function(callback = jQuery.noop) {
    return this.toArray().map(n => $(n)).map(callback);
  };
  
  /**
   * Enables textarea to shrink and grow depending on height of text inside of it
   * @param delay
   */
  jQuery.fn.textareaElastic = function(delay = 5) {
    if (!this.is("textarea")) return;
    
    let old_h = this.height(),
      new_h;
    this.css('transition', 'none');
    // console.info('before: ', this.get(0).scrollHeight, ' | ', this.height());
    this.height(0);
    new_h = this.get(0).scrollHeight;
    // console.info('after: ', this.get(0).scrollHeight, ' | ', this.height());
    this.height(old_h);
    setTimeout(() => {
      this.css('transition', '');
      this.height(new_h);
      // console.info('after: ', this.get(0).scrollHeight, ' | ', this.height());
    }, delay);
  };
}